import {
	Button,
	Checkbox,
	Col,
	Divider,
	Form,
	Input,
	Row,
	Select,
	notification,
	Typography,
	Tabs,
	Upload,
	DatePicker,
	Flex,
	InputNumber,
	Radio,
	Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import {
	businessTypeOptions,
	customerTypeOptions,
	federalTaxClassificationOptions,
	franchiseOptions,
	notifiableOptions,
	paymentTermOptions,
	quadrantTypeOptions,
	rankingOptions,
} from "../../constants/Customer";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Option } = Select;
const { Title, Text } = Typography;

const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Payment Type",
		dataIndex: "paymentType",
		key: "paymentType",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const columnsPurchaseOrder = [
	{
		title: "Date Created",
		dataIndex: "date",
		key: "date",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "Expired Date",
		dataIndex: "expiredDate",
		key: "expiredDate",
		render: (value) => <Text>{value}</Text>,
	},
	{
		title: "File",
		dataIndex: "fileUrl",
		key: "fileUrl",
		render: (value) => (
			<Typography.Link href={value} target="_blank" rel="noopener noreferrer">
				View File
			</Typography.Link>
		),
	},
];

const CustomerProfile = (props) => {
	const [form] = Form.useForm();
	const [formCredit] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [loadingCredit, setLoadingCredit] = useState(true);
	const [name, setName] = useState("");
	const [customerNumber, setCustomerNumber] = useState("");
	const [userId, setUserId] = useState("");
	const [creditHold, setCreditHold] = useState(false);
	const [initialValues, setInitialValues] = useState({});
	const [initialValues2, setInitialValues2] = useState({});
	const [paymentTypeHistoryData, setPaymentTypeHistoryData] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [sellerOptions, setSellerOptions] = useState([]);
	const [sellerDisabled, setSellerDisabled] = useState();
	const [isCredit, setIsCredit] = useState(false);
	const [creditApplicationCreated, setCreditApplicationCreated] =
		useState(false);
	const [loadingButton, setLoadingButton] = useState(false);
	const [franchise, setFranchise] = useState("57Concrete");
	const [hasSignedW9Form, setHasSignedW9Form] = useState(false);
	const [signedW9Form, setSignedW9Form] = useState("");
	const [hasCreditApplication, setHasCreditApplication] = useState(false);
	const [creditApplication, setCreditApplication] = useState("");
	const [hasTaxCertificate, setHasTaxCertificate] = useState(false);
	const [taxCertificate, setTaxCertificate] = useState("");
	const [creditApproved, setCreditApproved] = useState(false);

	const [businessType, setBusinessType] = useState("");
	const [activeKey, setActiveKey] = useState("1");

	const [loadingOption, setLoadingOption] = useState(true);

	const [openPurchaseOrderModal, setOpenPurchaseOrderModal] = useState(false);
	const [purchaseOrders, setPurchaseOrders] = useState([]);
	const [purchaseOrdersList, setPurchaseOrdersList] = useState([]);
	const [loadingPurchaseOrder, setLoadingPurchaseOrder] = useState(false);
	const [pendingPurchaseOrder, setPendingPurchaseOrder] = useState(null);
	const [formPurchaseOrder] = Form.useForm();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const allowedEmails = [
		"eliud@gmail.com",
		"mgr@57concrete.com",
		"bm@57concrete.com",
		"gg@57xgroup.com",
		"ec@57concrete.com",
	];

	const canEditPaymentTerm = allowedEmails.includes(
		localStorage.getItem("email"),
	);

	useEffect(() => {
		Promise.all([getSellerList(), checkCredit()]).then(() => {
			setLoadingOption(false);
		});
	}, []);

	const checkCredit = async () => {
		const url = api + "/credit/check/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				if (data.payload) {
					setCreditApplicationCreated(true);
					await getCredit();
				} else {
					setCreditApplicationCreated(false);
					setLoadingCredit(false);
					setCreditApproved(false);
					setInitialValues2({
						...initialValues2,
						state: "TX",
						poRequired: false,
						taxExempt: false,
						invoiceMethod: "Email",
						acceptConditions: false,
						prefix: "+1",
					});
				}
			} else {
				setLoadingCredit(false);
				setCreditApplicationCreated(false);
				setCreditApproved(false);
				setInitialValues2({
					...initialValues2,
					state: "TX",
					poRequired: false,
					taxExempt: false,
					invoiceMethod: "Email",
					acceptConditions: false,
					prefix: "+1",
				});
			}
		} catch (err) {
			setLoadingCredit(false);
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const getCredit = async () => {
		setLoadingCredit(true);

		try {
			const url = api + "/credit/get/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;

				let owner1 = {};
				let owner2 = {};
				let owner3 = {};
				if (payload.owners.length === 1) {
					owner1 = payload.owners[0];
				} else if (payload.owners.length === 2) {
					owner1 = payload.owners[0];
					owner2 = payload.owners[1];
				} else if (payload.owners.length === 3) {
					owner1 = payload.owners[0];
					owner2 = payload.owners[1];
					owner3 = payload.owners[2];
				}

				let reference1 = {};
				let reference2 = {};
				let reference3 = {};
				if (payload.references.length === 1) {
					reference1 = payload.references[0];
				} else if (payload.references.length === 2) {
					reference1 = payload.references[0];
					reference2 = payload.references[1];
				} else if (payload.references.length === 3) {
					reference1 = payload.references[0];
					reference2 = payload.references[1];
					reference3 = payload.references[2];
				}

				let guarantor1 = {};
				let guarantor2 = {};
				if (payload.guarantors.length === 1) {
					guarantor1 = payload.guarantors[0];
				} else if (payload.guarantors.length === 2) {
					guarantor1 = payload.guarantors[0];
					guarantor2 = payload.guarantors[1];
				}

				setInitialValues2({
					...initialValues2,

					prefix: "+1",
					id: payload._id,

					amountOfCredit: payload.amountOfCredit,
					monthlyPurchases: payload.monthlyPurchases,
					termsOfSales: payload.termsOfSales,
					numberOfEmployees: payload.numberOfEmployees,
					businessStartDate: dayjs(payload.businessStartDate),

					address: payload.address,
					city: payload.city,
					county: payload.county,
					state: payload.state,
					zip: payload.zip,
					sameAddress: payload.sameAddress,
					mailingAddress: payload.mailingAddress,
					mailingCity: payload.mailingCity,
					mailingCounty: payload.mailingCounty,
					mailingState: payload.mailingState,
					mailingZip: payload.mailingZip,
					email: payload.email,
					phone: payload.phone
						? payload.phone.substring(0, 2) === "+1"
							? payload.phone.substring(2)
							: payload.phone
						: undefined,
					fax: payload.fax,

					primaryContact: payload.primaryContact,
					primaryPosition: payload.primaryPosition,
					primaryPhone: payload.primaryPhone
						? payload.primaryPhone.substring(0, 2) === "+1"
							? payload.primaryPhone.substring(2)
							: payload.primaryPhone
						: undefined,
					primaryEmail: payload.primaryEmail,
					apContact: payload.apContact,
					apPosition: payload.apPosition,
					apPhone: payload.apPhone
						? payload.apPhone.substring(0, 2) === "+1"
							? payload.apPhone.substring(2)
							: payload.apPhone
						: undefined,
					apEmail: payload.apEmail,
					apEmailSecondary: payload.apEmailSecondary,

					businessType: payload.businessType,
					businessTypeOther: payload.businessTypeOther,

					//owners
					ownerName1: owner1.ownerName,
					ownerPosition1: owner1.ownerPosition,
					ownerOwned1: owner1.ownerOwned,
					ownerAddress1: owner1.ownerAddress,
					ownerPhone1: owner1.ownerPhone
						? owner1.ownerPhone.substring(2)
						: undefined,

					ownerName2: owner2.ownerName,
					ownerPosition2: owner2.ownerPosition,
					ownerOwned2: owner2.ownerOwned,
					ownerAddress2: owner2.ownerAddress,
					ownerPhone2: owner2.ownerPhone
						? owner2.ownerPhone.substring(2)
						: undefined,

					ownerName3: owner3.ownerName,
					ownerPosition3: owner3.ownerPosition,
					ownerOwned3: owner3.ownerOwned,
					ownerAddress3: owner3.ownerAddress,
					ownerPhone3: owner3.ownerPhone
						? owner3.ownerPhone.substring(2)
						: undefined,

					bankName: payload.bankName,
					bankContact: payload.bankContact,
					bankAddress: payload.bankAddress,
					bankPhone: payload.bankPhone
						? payload.bankPhone.substring(0, 2) === "+1"
							? payload.bankPhone.substring(2)
							: payload.bankPhone
						: undefined,
					bankAccount: payload.bankAccount,

					//references
					referenceName1: reference1.referenceName,
					referenceAddress1: reference1.referenceAddress,
					referencePhone1: reference1.referencePhone
						? reference1.referencePhone.substring(2)
						: undefined,
					referenceEmail1: reference1.referenceEmail,

					referenceName2: reference2.referenceName,
					referenceAddress2: reference2.referenceAddress,
					referencePhone2: reference2.referencePhone
						? reference2.referencePhone.substring(2)
						: undefined,
					referenceEmail2: reference2.referenceEmail,

					referenceName3: reference3.referenceName,
					referenceAddress3: reference3.referenceAddress,
					referencePhone3: reference3.referencePhone
						? reference3.referencePhone.substring(2)
						: undefined,
					referenceEmail3: reference3.referenceEmail,

					poRequired: payload.poRequired || false,
					taxExempt: payload.taxExempt || false,
					invoiceMethod: payload.invoiceMethod,
					invoiceSendTo: payload.invoiceSendTo,

					signatureName: payload.signatureName,
					signatureEmail: payload.signatureEmail,
					signaturePhone: payload.signaturePhone
						? payload.signaturePhone.substring(0, 2) === "+1"
							? payload.signaturePhone.substring(2)
							: payload.signaturePhone
						: undefined,
					signatureDate: payload.signatureDate
						? dayjs(payload.signatureDate)
						: undefined,

					//guarantors
					guarantorName1: guarantor1.guarantorName,
					guarantorSS1: guarantor1.guarantorSSNumber,
					guarantorPosition1: guarantor1.guarantorPosition,
					guarantorDate1: dayjs(guarantor1.guarantorDate),
					guarantorPhone1: guarantor1.guarantorPhone
						? guarantor1.guarantorPhone.substring(2)
						: undefined,
					guarantorAddress1: guarantor1.guarantorAddress,
					guarantorCity1: guarantor1.guarantorCity,
					guarantorState1: guarantor1.guarantorState,
					guarantorZip1: guarantor1.guarantorZip,

					guarantorName2: guarantor2.guarantorName,
					guarantorSS2: guarantor2.guarantorSSNumber,
					guarantorPosition2: guarantor2.guarantorPosition,
					guarantorDate2: dayjs(guarantor2.guarantorDate),
					guarantorPhone2: guarantor2.guarantorPhone
						? guarantor2.guarantorPhone.substring(2)
						: undefined,
					guarantorAddress2: guarantor2.guarantorAddress,
					guarantorCity2: guarantor2.guarantorCity,
					guarantorState2: guarantor2.guarantorState,
					guarantorZip2: guarantor2.guarantorZip,
				});

				//certificate tax exempt
				setHasTaxCertificate(payload.taxExemptCertificateUrl ? true : false);
				setTaxCertificate(payload.taxExemptCertificateUrl);

				setCreditApproved(payload.creditApproved || false);

				setLoadingCredit(false);
			} else {
				openNotification("error", "Error", data.message);
				setLoadingCredit(false);
			}
		} catch (err) {
			setLoadingCredit(false);

			openNotification("error", "Error", "Error while trying to get credit");
			console.error(err.message);
			return null;
		}
	};

	const getClient = async () => {
		const url = api + "/customer/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			let hasPhone = data.sms ? true : false;

			setInitialValues({
				...initialValues,
				name: data.name,
				email: data.email,
				sms: hasPhone
					? data.sms
						? data.sms.substring(0, 2) === "+1"
							? data.sms.substring(2)
							: data.sms
						: ""
					: data.contactPhone
						? data.contactPhone.substring(0, 2) === "+1"
							? data.contactPhone.substring(2)
							: data.contactPhone
						: "",
				customerType: data.customerType,
				quadrantType: data.quadrantType || undefined,
				contactName: data.contactName ? data.contactName : "",
				dba: data.dba,
				taxId: data.taxId,
				contactPosition: data.contactPosition,
				customerNumber: data.customerNumber,
				notifiableEvents: data.notifiableEvents,
				address: data.address,
				city: data.city,
				state: data.state,
				zip: data.zip,
				county: data.county,

				accountsPayableContact: data.accountsPayableContact,
				accountsPayableEmail: data.accountsPayableEmail,
				accountsPayablePhone: data.accountsPayablePhone
					? data.accountsPayablePhone.substring(0, 2) === "+1"
						? data.accountsPayablePhone.substring(2)
						: data.accountsPayablePhone
					: "",

				prefix: "+1",
				cashAccount: data.paymentType === "PrePay" ? true : false,
				creditAccount: data.paymentType === "PrePay" ? false : true,
				paymentTerm:
					data.paymentTerm &&
					data.paymentTerm !== null &&
					data.paymentTerm !== undefined &&
					data.paymentTerm !== ""
						? data.paymentTerm
						: data.paymentType === "PrePay"
							? "Prepayment"
							: "7",
				federalTaxClassification: data.federalTaxClassification,
				isActivePouredUser: data.contact
					? data.contact.isActivePouredUser
						? data.contact.isActivePouredUser
						: false
					: false,
				pouredEmail: data.contact
					? data.contact.pouredEmail
						? data.contact.pouredEmail
						: ""
					: "",
				franchise: data.franchise ? data.franchise : "57Concrete",
				prospectionSeller: data.prospectionSeller,
				ranking: data.ranking || "C",
				assignedSalesRep: data.createdBy ? data.createdBy.name : "",
				date: dayjs(data.createdAt),
				creditHold: data.creditHold || false,
			});

			setIsCredit(data.paymentType === "Credit");

			setHasSignedW9Form(data.signedW9Form || false);
			setSignedW9Form(data.signedW9Form || "");
			setHasCreditApplication(data.creditApplication || false);
			setCreditApplication(data.creditApplication || "");
			setPurchaseOrders(data.purchaseOrders || []);

			const purchaseOrdersList = [];

			data.purchaseOrdersList.map((item, index) => {
				purchaseOrdersList.push({
					key: index,
					date: Intl.DateTimeFormat("en-US", {
						month: "numeric",
						year: "numeric",
						day: "numeric",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
					}).format(new Date(item.createdAt)),
					expiredDate: Intl.DateTimeFormat("en-US", {
						month: "numeric",
						year: "numeric",
						day: "numeric",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
					}).format(new Date(item.expiredDate)),
					user: item.user.name,
					fileUrl: item.fileUrl,
				});
			});
			setPurchaseOrdersList(purchaseOrdersList);

			const paymentTypeHistory = [];

			data.paymentTypeHistory.map((item, index) => {
				paymentTypeHistory.push({
					key: index,
					date: Intl.DateTimeFormat("en-US", {
						month: "numeric",
						year: "numeric",
						day: "numeric",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
					}).format(new Date(item.createdAt)),
					user: item.user.name,
					paymentType: item.paymentType,
				});
			});
			setPaymentTypeHistoryData(paymentTypeHistory);

			setCreditHold(data.creditHold ? data.creditHold : false);
			setUserId(data.contact ? data.contact._id : "");
			setCustomerNumber(data.customerNumber);
			setName(data.name);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get customer");
			console.error(err.message);
			return null;
		}
	};

	const onSendCreditApplication = async () => {
		const url = api + `/customer/send/creditform/${props.match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoadingButton(true);
			const { data } = await axios.post(url);
			if (data.success) {
				openNotification("success", "Success", data.message);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingButton(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const getSellerList = async () => {
		const url = api + "/user/list/57Concrete/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label: item.name,
					});
				});
				setSellerOptions(list);

				const email = localStorage.getItem("email");
				if (
					email === "eliud@gmail.com" ||
					email === "ec@57concrete.com" ||
					email === "rl@57concrete.com" ||
					email === "jh@57concrete.com" ||
					email === "bpa@57concrete.com" ||
					email === "pc@57concrete.com" ||
					email === "gg@57xgroup.com" ||
					email === "scale@filegonia.com" ||
					email === "jc@57concrete.com" ||
					email === "reyesss22@icloud.com" ||
					email === "office@57logistics.com"
				) {
					setSellerDisabled(false);
				} else {
					setSellerDisabled(true);
				}
				getClient();
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const updateClient = async (datas) => {
		setLoading(true);

		const url = api + "/customer/" + props.match.params.id;
		const url2 = api + "/user/customer/poured/update/" + userId;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		const formData = new FormData();
		formData.append("name", datas.name);
		formData.append("email", datas.email);
		formData.append("sms", `+1${datas.sms}`);
		formData.append("customerType", datas.customerType);
		formData.append("quadrantType", datas.quadrantType);
		formData.append("dba", datas.dba);
		formData.append("taxId", datas.taxId);
		formData.append("contactPosition", datas.contactPosition);

		formData.append("address", datas.address);
		formData.append("city", datas.city);
		formData.append("state", datas.state);
		formData.append("zip", datas.zip);
		formData.append("county", datas.county);

		formData.append("contactPhone", `+1${datas.sms}`);
		formData.append("contactName", datas.contactName);
		formData.append("accountsPayableContact", datas.accountsPayableContact);
		formData.append("accountsPayableEmail", datas.accountsPayableEmail);
		formData.append("accountsPayablePhone", `+1${datas.accountsPayablePhone}`);

		formData.append("paymentType", datas.cashAccount ? "PrePay" : "Credit");
		formData.append("paymentTerm", datas.paymentTerm);
		formData.append("federalTaxClassification", datas.federalTaxClassification);

		formData.append("ranking", datas.ranking);
		formData.append("prospectionSeller", datas.prospectionSeller);
		formData.append("franchise", datas.franchise);

		formData.append("creditHold", datas.creditHold);
		formData.append("updatedBy", localStorage.getItem("userId"));

		formData.append("notifiableEvents", JSON.stringify(datas.notifiableEvents));

		if (datas.signedW9Form && datas.signedW9Form.length > 0) {
			formData.append("signedW9Form", datas.signedW9Form[0].originFileObj);
		}
		if (datas.creditApplication && datas.creditApplication.length > 0) {
			formData.append(
				"creditApplication",
				datas.creditApplication[0].originFileObj,
			);
		}

		if (pendingPurchaseOrder) {
			formData.append("purchaseOrder", pendingPurchaseOrder.file);
			formData.append(
				"expiredDate",
				dayjs(pendingPurchaseOrder.expiredDate).toDate(),
			);
		}

		const pouredClient = {
			isActivePouredUser: datas.isActivePouredUser,
			pouredEmail: datas.pouredEmail,
			pouredRole: "Customer",
		};

		if (datas.isActivePouredUser) {
			if (datas.pouredEmail === "") {
				setLoading(false);
				openNotification(
					"warning",
					"Warning",
					"If Customer Poured is active, it needs an email",
				);
				return null;
			}
		}

		try {
			await axios.patch(url, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			if (userId !== "") await axios.patch(url2, pouredClient);

			openNotification("success", "Success", "Customer Updated");
			setTimeout(() => {
				setLoading(false);
				props.history.push("/listacliente");
			}, 2000);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update user");
			console.error(err.message);
			return null;
		}
	};

	const goCreateJob = () => {
		localStorage.setItem("customerName", name);
		localStorage.setItem("customerNumber", customerNumber);
		const url = "/jobnuevo";
		props.history.push(url);
	};

	const goPdfForm = () => {
		const url = "/clientpdf/" + props.match.params.id;
		props.history.push(url);
	};

	const updateHoldCredit = async () => {
		setLoading(true);
		const url = api + "/customer/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const body = {
				creditHold: !creditHold,
			};
			await axios.patch(url, body);
			openNotification("info", "Info", "Credit Hold Updated");
			setLoading(false);
			props.history.push("/listacliente");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const updateCreditApproved = async () => {
		setLoadingCredit(true);
		const url = api + "/credit/set/approved/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);

			if (data.success) {
				setCreditApproved(true);
				openNotification("success", "Success", data.message);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoadingCredit(false);
		} catch (err) {
			setLoadingCredit(false);
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const deleteClient = async () => {
		const url = api + "/customer/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Customer Deleted");
			setLoading(false);
			props.history.push("/listacliente");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onFinish = () => {
		const values = form.getFieldsValue(true);
		updateClient(values);
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Option value="+1">+1</Option>
			</Select>
		</Form.Item>
	);

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24} md={12}>
						<Form.Item
							label="Legal Company Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill company name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={6}>
						<Form.Item label="DBA" name="dba">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={6}>
						<Form.Item label="EIN/Tax ID (W-9)" name="taxId">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Customer Type"
							name="customerType"
							rules={[
								{
									required: true,
									message: "Please select customer type",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select customer type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={customerTypeOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Quadrant Type"
							name="quadrantType"
							rules={[
								{
									required: true,
									message: "Please select quadrant type",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select quadrant type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={quadrantTypeOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} md={12}>
						<Form.Item
							label="Primary Contact Name"
							name="contactName"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item label="Title / Position" name="contactPosition">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Primary Contact Phone"
							name="sms"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Primary Contact Email"
							name="email"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Notifiable Events" name="notifiableEvents">
							<Select
								showSearch
								labelInValue
								placeholder={`Select notifiable events`}
								size="large"
								mode="multiple"
								options={notifiableOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item
							label="Company Address"
							name="address"
							rules={[
								{
									required: true,
									message: "Please fill address",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>

					<Col span={24} md={4}>
						<Form.Item
							label="City"
							name="city"
							rules={[
								{
									required: true,
									message: "Please fill city",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item
							label="State"
							name="state"
							rules={[
								{
									required: true,
									message: "Please fill state",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>

					<Col span={24} md={4}>
						<Form.Item
							label="ZIP Code"
							name="zip"
							rules={[
								{
									required: true,
									message: "Please fill zip",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item label="County" name="county">
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item
							label="Primary A/P Contact Name"
							name="accountsPayableContact"
							rules={[
								{
									required: true,
									message: "Please fill contact name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Primary A/P Contact Phone"
							name="accountsPayablePhone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Primary A/P Contact Email"
							name="accountsPayableEmail"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item name="cashAccount" valuePropName="checked">
							<Checkbox
								onChange={(e) => {
									if (e.target.checked) {
										form.setFieldValue("creditAccount", false);
										form.setFieldValue("paymentTerm", "Prepayment");
										setIsCredit(false);
									} else {
										form.setFieldValue("creditAccount", true);
										form.setFieldValue("paymentTerm", "7");
										setIsCredit(true);
									}
								}}
								disabled={
									!(
										localStorage.getItem("role") === "Finance" ||
										localStorage.getItem("email") === "vo@57concrete.com" ||
										localStorage.getItem("email") === "vp@57concrete.com" ||
										localStorage.getItem("email") === "mgr@57concrete.com" ||
										localStorage.getItem("email") === "bm@57concrete.com" ||
										localStorage.getItem("email") === "jp@57concrete.com" ||
										localStorage.getItem("email") === "ec@57concrete.com" ||
										localStorage.getItem("email") === "eliud@gmail.com" ||
										localStorage.getItem("email") === "pc@57concrete.com" ||
										localStorage.getItem("email") === "gg@57xgroup.com" ||
										localStorage.getItem("email") === "scale@filegonia.com" ||
										localStorage.getItem("email") === "jc@57concrete.com" ||
										localStorage.getItem("email") === "reyesss22@icloud.com" ||
										localStorage.getItem("email") === "office@57logistics.com"
									)
								}
							>
								Cash Account ( Prepayment or COD - no credit terms extended)
							</Checkbox>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item name="creditAccount" valuePropName="checked">
							<Checkbox
								onChange={(e) => {
									if (e.target.checked) {
										form.setFieldValue("cashAccount", false);
										form.setFieldValue("paymentTerm", "7");
										setIsCredit(true);
									} else {
										form.setFieldValue("cashAccount", true);
										form.setFieldValue("paymentTerm", "Prepayment");
										setIsCredit(false);
									}
								}}
								disabled={
									!(
										localStorage.getItem("role") === "Finance" ||
										localStorage.getItem("email") === "vo@57concrete.com" ||
										localStorage.getItem("email") === "vp@57concrete.com" ||
										localStorage.getItem("email") === "mgr@57concrete.com" ||
										localStorage.getItem("email") === "bm@57concrete.com" ||
										localStorage.getItem("email") === "jp@57concrete.com" ||
										localStorage.getItem("email") === "ec@57concrete.com" ||
										localStorage.getItem("email") === "eliud@gmail.com" ||
										localStorage.getItem("email") === "pc@57concrete.com" ||
										localStorage.getItem("email") === "gg@57xgroup.com" ||
										localStorage.getItem("email") === "scale@filegonia.com" ||
										localStorage.getItem("email") === "jc@57concrete.com" ||
										localStorage.getItem("email") === "reyesss22@icloud.com" ||
										localStorage.getItem("email") === "office@57logistics.com"
									)
								}
							>
								Credit Account ( Credit App required - Tab 2)
							</Checkbox>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Payment Term"
							name="paymentTerm"
							rules={[
								{
									required: true,
									message: "Please select payment term",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select payment term`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={paymentTermOptions}
								style={{
									width: "100%",
								}}
								disabled={!canEditPaymentTerm}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={12}>
						<Form.Item
							label="Federal Tax Classification"
							name="federalTaxClassification"
						>
							<Select
								showSearch
								placeholder={`Select federal tax classification`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={federalTaxClassificationOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item
							label="Signed W-9 Form Attached"
							name="signedW9Form"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									disabled={hasSignedW9Form}
								>
									Upload
								</Button>
							</Upload>
							{hasSignedW9Form && (
								<Text
									type="success"
									style={{ underline: true, cursor: "pointer" }}
									onClick={() => {
										const link = document.createElement("a");
										link.href = signedW9Form;
										link.target = "_blank";
										document.body.appendChild(link);
										link.click();
										link.remove();
									}}
								>
									W-9 form already attached
								</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item label="Purchase Order">
							<Button
								size="large"
								type="primary"
								htmlType="button"
								onClick={() => setOpenPurchaseOrderModal(true)}
							>
								{purchaseOrders.length > 0
									? "View Purchase Order"
									: "Add Purchase Order"}
							</Button>
						</Form.Item>
					</Col>
					<Col span={24} md={4}>
						<Form.Item
							label="Credit Application Attached"
							name="creditApplication"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									disabled={hasCreditApplication}
								>
									Upload
								</Button>
							</Upload>
							{hasCreditApplication && (
								<Text
									type="success"
									style={{ underline: true, cursor: "pointer" }}
									onClick={() => {
										const link = document.createElement("a");
										link.href = creditApplication;
										link.target = "_blank";
										document.body.appendChild(link);
										link.click();
										link.remove();
									}}
								>
									Credit Application already attached
								</Text>
							)}
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} md={8}>
						<Form.Item
							label="Ranking"
							name="ranking"
							rules={[
								{
									required: true,
									message: "Please select ranking",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select ranking`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={rankingOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Franchise"
							name="franchise"
							rules={[
								{
									required: true,
									message: "Please select franchise",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select franchise`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={franchiseOptions}
								style={{
									width: "100%",
								}}
								allowClear={false}
								disabled={
									!(
										localStorage.getItem("email") === "eliud@gmail.com" ||
										localStorage.getItem("email") === "ec@57concrete.com" ||
										localStorage.getItem("email") === "bpa@57concrete.com" ||
										localStorage.getItem("email") === "pc@57concrete.com" ||
										localStorage.getItem("email") === "gg@57xgroup.com" ||
										localStorage.getItem("email") === "scale@filegonia.com" ||
										localStorage.getItem("email") === "jc@57concrete.com" ||
										localStorage.getItem("email") === "reyesss22@icloud.com" ||
										localStorage.getItem("email") === "office@57logistics.com"
									)
								}
								onChange={onChangeFranchise}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item label="Seller" name="prospectionSeller">
							<Select
								showSearch
								placeholder={`Select payment seller`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={sellerOptions}
								style={{
									width: "100%",
								}}
								disabled={sellerDisabled || franchise === "Valley Wide"}
							/>
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item
							label="Assigned Sales Representative"
							name="assignedSalesRep"
						>
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item label="Customer Account #" name="customerNumber">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={24} md={8}>
						<Form.Item label="Date of Submission" name="date">
							<DatePicker
								size="large"
								disabled
								format="MM/DD/YYYY hh:mm A"
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={6}>
						<Form.Item name="creditHold" valuePropName="checked">
							<Checkbox
								disabled={
									!(
										localStorage.getItem("email") === "mv@57concrete.com" ||
										localStorage.getItem("email") === "al@57concrete.com" ||
										localStorage.getItem("email") === "ec@57concrete.com" ||
										localStorage.getItem("email") === "mgr@57concrete.com" ||
										localStorage.getItem("email") === "cdl@57concrete.com" ||
										localStorage.getItem("email") === "bp@57concrete.com" ||
										localStorage.getItem("email") === "bpa@57concrete.com" ||
										localStorage.getItem("email") === "mb@57concrete.com" ||
										localStorage.getItem("email") === "vo@57concrete.com" ||
										localStorage.getItem("email") === "wc@57concrete.com" ||
										localStorage.getItem("email") === "bm@57concrete.com" ||
										localStorage.getItem("email") === "eliud@gmail.com" ||
										localStorage.getItem("email") === "pc@57concrete.com" ||
										localStorage.getItem("email") === "gg@57xgroup.com" ||
										localStorage.getItem("email") === "scale@filegonia.com" ||
										localStorage.getItem("email") === "jc@57concrete.com" ||
										localStorage.getItem("email") === "reyesss22@icloud.com" ||
										localStorage.getItem("email") === "office@57logistics.com"
									)
								}
							>
								Hold Credit
							</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				{userId !== "" && (
					<>
						<Divider style={{ margin: "12px 0px" }} />
						<Title level={3}>Customer Poured Details</Title>
						<Row gutter={16}>
							<Col span={24}>
								<Form.Item name="isActivePouredUser" valuePropName="checked">
									<Checkbox>Is Active Poured User?</Checkbox>
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									label="Poured Email"
									name="pouredEmail"
									rules={[
										{
											type: "email",
											message: "The input is not valid E-mail",
										},
									]}
								>
									<Input size="large" />
								</Form.Item>
							</Col>
						</Row>
					</>
				)}
				<Divider />
				<Title level={3}>Payment Type History</Title>
				<CustomTable
					columns={columns}
					data={paymentTypeHistoryData}
					isScroll={false}
				/>
				<Divider />
				<Row gutter={16}>
					<Col>
						<Button type="primary" htmlType="submit" loading={loading}>
							Save
						</Button>
					</Col>
					<Col>
						<Button
							type="default"
							htmlType="button"
							loading={loading}
							onClick={goCreateJob}
						>
							Create Job
						</Button>
					</Col>
					<Col>
						<Button
							type="primary"
							danger
							htmlType="button"
							loading={loading}
							onClick={goPdfForm}
						>
							PDF
						</Button>
					</Col>
					{(localStorage.getItem("email") === "mv@57concrete.com" ||
						localStorage.getItem("email") === "al@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "cdl@57concrete.com" ||
						localStorage.getItem("email") === "bp@57concrete.com" ||
						localStorage.getItem("email") === "mgr@57concrete.com" ||
						localStorage.getItem("email") === "bpa@57concrete.com" ||
						localStorage.getItem("email") === "mb@57concrete.com" ||
						localStorage.getItem("email") === "vo@57concrete.com" ||
						localStorage.getItem("email") === "wc@57concrete.com" ||
						localStorage.getItem("email") === "bm@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "scale@filegonia.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "reyesss22@icloud.com" ||
						localStorage.getItem("email") === "office@57logistics.com") && (
						<Col>
							<Button
								type="primary"
								htmlType="button"
								loading={loading}
								onClick={updateHoldCredit}
							>
								{creditHold ? "Remove Hold Credit" : "Set Hold Credit"}
							</Button>
						</Col>
					)}
				</Row>
			</Form>
		);
	};

	const onChangeSameAddress = (e) => {
		const checked = e.target.checked;
		if (checked) {
			const { address, city, county, state, zip } = formCredit.getFieldsValue([
				"address",
				"city",
				"county",
				"state",
				"zip",
			]);

			formCredit.setFieldsValue({
				mailingAddress: address,
				mailingCity: city,
				mailingCounty: county,
				mailingState: state,
				mailingZip: zip,
			});
		} else {
			formCredit.setFieldsValue({
				mailingAddress: undefined,
				mailingCity: undefined,
				mailingCounty: undefined,
				mailingState: undefined,
				mailingZip: undefined,
			});
		}
	};

	const addOwners = (values) => {
		let owners = [];

		if (values.ownerName1) {
			let owner = {
				ownerName: values.ownerName1,
				ownerPosition: values.ownerPosition1,
				ownerOwned: values.ownerOwned1,
				ownerAddress: values.ownerAddress1,
				ownerPhone: values.ownerPhone1 ? `+1${values.ownerPhone1}` : undefined,
			};
			owners.push(owner);
		}

		if (values.ownerName2) {
			let owner = {
				ownerName: values.ownerName2,
				ownerPosition: values.ownerPosition2,
				ownerOwned: values.ownerOwned2,
				ownerAddress: values.ownerAddress2,
				ownerPhone: values.ownerPhone2 ? `+1${values.ownerPhone2}` : undefined,
			};
			owners.push(owner);
		}

		if (values.ownerName3) {
			let owner = {
				ownerName: values.ownerName3,
				ownerPosition: values.ownerPosition3,
				ownerOwned: values.ownerOwned3,
				ownerAddress: values.ownerAddress3,
				ownerPhone: values.ownerPhone3 ? `+1${values.ownerPhone3}` : undefined,
			};
			owners.push(owner);
		}

		return owners;
	};

	const addReferences = (values) => {
		let referencias = [];

		if (values.referenceName1) {
			let refe = {
				referenceName: values.referenceName1,
				referenceAddress: values.referenceAddress1,
				referencePhone: values.referencePhone1
					? `+1${values.referencePhone1}`
					: undefined,
				referenceEmail: values.referenceEmail1,
			};
			referencias.push(refe);
		}

		if (values.referenceName2) {
			let refe = {
				referenceName: values.referenceName2,
				referenceAddress: values.referenceAddress2,
				referencePhone: values.referencePhone2
					? `+1${values.referencePhone2}`
					: undefined,
				referenceEmail: values.referenceEmail2,
			};
			referencias.push(refe);
		}

		if (values.referenceName3) {
			let refe = {
				referenceName: values.referenceName3,
				referenceAddress: values.referenceAddress3,
				referencePhone: values.referencePhone3
					? `+1${values.referencePhone3}`
					: undefined,
				referenceEmail: values.referenceEmail3,
			};
			referencias.push(refe);
		}

		return referencias;
	};

	const addGrutors = (values) => {
		let avales = [];

		if (values.guarantorName1) {
			let aval = {
				guarantorName: values.guarantorName1,
				guarantorSSNumber: values.guarantorSS1,
				guarantorPosition: values.guarantorPosition1,
				guarantorDate: values.guarantorDate1
					? dayjs(values.guarantorDate1).toDate()
					: undefined,
				guarantorPhone: values.guarantorPhone1
					? `+1${values.guarantorPhone1}`
					: undefined,
				guarantorAddress: values.guarantorAddress1,
				guarantorCity: values.guarantorCity1,
				guarantorState: values.guarantorState1,
				guarantorZip: values.guarantorZip1,
			};
			avales.push(aval);
		}

		if (values.guarantorName2) {
			let aval = {
				guarantorName: values.guarantorName2,
				guarantorSSNumber: values.guarantorSS2,
				guarantorPosition: values.guarantorPosition2,
				guarantorDate: values.guarantorDate2
					? dayjs(values.guarantorDate2).toDate()
					: undefined,
				guarantorPhone: values.guarantorPhone2
					? `+1${values.guarantorPhone2}`
					: undefined,
				guarantorAddress: values.guarantorAddress2,
				guarantorCity: values.guarantorCity2,
				guarantorState: values.guarantorState2,
				guarantorZip: values.guarantorZip2,
			};
			avales.push(aval);
		}

		return avales;
	};

	const updateCredit = async (values) => {
		setLoadingCredit(true);
		const formData = new FormData();

		formData.append("numberOfEmployees", values.numberOfEmployees);
		formData.append("amountOfCredit", values.amountOfCredit);
		formData.append("monthlyPurchases", values.monthlyPurchases);
		formData.append("termsOfSales", values.termsOfSales);
		formData.append(
			"businessStartDate",
			values.businessStartDate
				? dayjs(values.businessStartDate).toDate()
				: undefined,
		);

		formData.append("address", values.address);
		formData.append("city", values.city);
		formData.append("county", values.county);
		formData.append("state", values.state);
		formData.append("zip", values.zip);
		formData.append("sameAddress", values.sameAddress);
		formData.append("mailingAddress", values.mailingAddress);
		formData.append("mailingCity", values.mailingCity);
		formData.append("mailingCounty", values.mailingCounty);
		formData.append("mailingState", values.mailingState);
		formData.append("mailingZip", values.mailingZip);
		formData.append("email", values.email);
		formData.append("phone", values.phone ? `+1${values.phone}` : undefined);
		formData.append("fax", values.fax);

		formData.append("primaryContact", values.primaryContact);
		formData.append("primaryPosition", values.primaryPosition);
		formData.append(
			"primaryPhone",
			values.primaryPhone ? `+1${values.primaryPhone}` : undefined,
		);
		formData.append("primaryEmail", values.primaryEmail);
		formData.append("apContact", values.apContact);
		formData.append("apPosition", values.apPosition);
		formData.append(
			"apPhone",
			values.apPhone ? `+1${values.apPhone}` : undefined,
		);
		formData.append("apEmail", values.apEmail);
		formData.append("apEmailSecondary", values.apEmailSecondary);

		formData.append("businessType", values.businessType);
		formData.append("businessTypeOther", values.businessTypeOther);

		const owners = addOwners(values);
		if (owners.length > 0) {
			formData.append("owners", JSON.stringify(owners));
		}

		formData.append("bankName", values.bankName);
		formData.append("bankContact", values.bankContact);
		formData.append("bankAddress", values.bankAddress);
		formData.append(
			"bankPhone",
			values.bankPhone ? `+1${values.bankPhone}` : undefined,
		);
		formData.append("bankAccount", values.bankAccount);

		const references = addReferences(values);
		if (references.length > 0) {
			formData.append("references", JSON.stringify(references));
		}

		formData.append("poRequired", values.poRequired);
		formData.append("taxExempt", values.taxExempt);
		formData.append("invoiceMethod", values.invoiceMethod);
		formData.append("invoiceSendTo", values.invoiceSendTo);
		if (values.taxExemptCertificate && values.taxExemptCertificate.length > 0) {
			formData.append(
				"taxExemptCertificate",
				values.taxExemptCertificate[0].originFileObj,
			);
		}

		formData.append("signatureName", values.signatureName);
		formData.append("signatureEmail", values.signatureEmail);
		formData.append(
			"signaturePhone",
			values.signaturePhone ? `+1${values.signaturePhone}` : undefined,
		);
		// formData.append(
		// 	"signatureDate",
		// 	values.signatureDate ? dayjs(values.signatureDate).toDate() : undefined,
		// );

		const guarantors = addGrutors(values);

		if (guarantors.length > 0) {
			formData.append("guarantors", JSON.stringify(guarantors));
		}

		try {
			if (creditApplicationCreated) {
				const url = api + `/credit/update/${values.id}`;
				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				};

				const { data } = await axios.patch(url, formData, config);
				if (data.success) {
					openNotification("success", "Success", data.message);
					setLoadingCredit(false);
					if (data.payload.taxExemptCertificateUrl) {
						setHasTaxCertificate(true);
						setTaxCertificate(data.payload.taxExemptCertificateUrl);
					}
				} else {
					setLoadingCredit(false);
					openNotification("error", "Error", data.message);
				}
			} else {
				const url = api + `/credit/create/jap/${props.match.params.id}`;
				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				};

				const { data } = await axios.post(url, formData, config);
				if (data.success) {
					setCreditApplicationCreated(true);
					openNotification("success", "Success", data.message);
					setLoadingCredit(false);
					if (data.payload.taxExemptCertificateUrl) {
						setHasTaxCertificate(true);
						setTaxCertificate(data.payload.taxExemptCertificateUrl);
					}
				} else {
					setLoadingCredit(false);
					openNotification("error", "Error", data.message);
				}
			}
		} catch (err) {
			setLoadingCredit(false);
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const onFinish2 = () => {
		const values = formCredit.getFieldsValue(true);
		updateCredit(values);
	};

	const CreditForm = () => (
		<Form
			form={formCredit}
			layout="vertical"
			onFinish={onFinish2}
			style={{ marginTop: "20px" }}
			initialValues={initialValues2}
		>
			<Row gutter={16}>
				<Col span={24} md={5}>
					<Form.Item
						label="Amount of Credit Requested ($)"
						name="amountOfCredit"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={5}>
					<Form.Item
						label="Estimated Monthly Purchases ($)"
						name="monthlyPurchases"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={5}>
					<Form.Item
						label="Business Start Date"
						name="businessStartDate"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<DatePicker
							size="large"
							format={"MM/DD/YYYY"}
							style={{ width: "100%" }}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={5}>
					<Form.Item
						label="Terms of Sales Requested (days)"
						name="termsOfSales"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={4}>
					<Form.Item
						label="Number of Employees"
						name="numberOfEmployees"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Business Address</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={8}>
					<Form.Item
						label="Street Address"
						name="address"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="City"
						name="city"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="County"
						name="county"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="State"
						name="state"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="Zip"
						name="zip"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item name="sameAddress" valuePropName="checked">
						<Checkbox onChange={onChangeSameAddress}>
							Mailing Address same as Street Address
						</Checkbox>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} sm={8}>
					<Form.Item label="Mailing Address" name="mailingAddress">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="City" name="mailingCity">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="County" name="mailingCounty">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="State" name="mailingState">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Zip" name="mailingZip">
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} sm={8}>
					<Form.Item
						label="Email"
						name="email"
						rules={[{ type: "email", message: "Email not valid" }]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={8}>
					<Form.Item label="Phone" name="phone">
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={8}>
					<Form.Item label="Fax" name="fax">
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Key Contacts</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={5}>
					<Form.Item
						label="Primary Contact"
						name="primaryContact"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Title/Position"
						name="primaryPosition"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Phone"
						name="primaryPhone"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Primary Email"
						name="primaryEmail"
						rules={[
							{ type: "email", message: "Email not valid" },
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} sm={5}>
					<Form.Item
						label="AP Contact"
						name="apContact"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Title/Position"
						name="apPosition"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Phone"
						name="apPhone"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Email"
						name="apEmail"
						rules={[
							{ type: "email", message: "Email not valid" },
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="Secondary Email"
						name="apEmailSecondary"
						rules={[
							{ type: "email", message: "Email not valid" },
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>

			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Type of Business</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={18}>
					<Form.Item
						label="Business Type"
						name="businessType"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Select
							options={businessTypeOptions}
							placeholder="Select business type"
							style={{ width: "100%" }}
							size="large"
							onChange={(value) => setBusinessType(value)}
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Other" name="businessTypeOther">
						<Input size="large" disabled={businessType !== "Other"} />
					</Form.Item>
				</Col>
			</Row>

			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Officers / Owners</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={6}>
					<Form.Item
						label="Name"
						name="ownerName1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="Title/Position"
						name="ownerPosition1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={2}>
					<Form.Item
						label="% Owned"
						name="ownerOwned1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={8}>
					<Form.Item
						label="Home address / City / State / ZIP"
						name="ownerAddress1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="Phone"
						name="ownerPhone1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Name" name="ownerName2">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Title/Position" name="ownerPosition2">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={2}>
					<Form.Item label="% Owned" name="ownerOwned2">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={8}>
					<Form.Item
						label="Home address / City / State / ZIP"
						name="ownerAddress2"
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Phone" name="ownerPhone2">
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Name" name="ownerName3">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Title/Position" name="ownerPosition3">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={2}>
					<Form.Item label="% Owned" name="ownerOwned3">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={8}>
					<Form.Item
						label="Home address / City / State / ZIP"
						name="ownerAddress3"
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Phone" name="ownerPhone3">
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Bank References</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={5}>
					<Form.Item
						label="Name"
						name="bankName"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Bank Officer/Contact"
						name="bankContact"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Address / City / State / ZIP"
						name="bankAddress"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={5}>
					<Form.Item
						label="Phone"
						name="bankPhone"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item
						label="Account #"
						name="bankAccount"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Trade References</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={6}>
					<Form.Item
						label="Business Name"
						name="referenceName1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Address / City / State / ZIP"
						name="referenceAddress1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Phone"
						name="referencePhone1"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Email"
						name="referenceEmail1"
						rules={[
							{ type: "email", message: "Email not valid" },
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Business Name" name="referenceName2">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Address / City / State / ZIP"
						name="referenceAddress2"
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Phone" name="referencePhone2">
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Email"
						name="referenceEmail2"
						rules={[{ type: "email", message: "Email not valid" }]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Business Name" name="referenceName3">
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Address / City / State / ZIP"
						name="referenceAddress3"
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item label="Phone" name="referencePhone3">
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Email"
						name="referenceEmail3"
						rules={[{ type: "email", message: "Email not valid" }]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Tax and Invoicing</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={4}>
					<Form.Item label="Taxable?" name="taxExempt">
						<Radio.Group>
							<Radio value={true}>Yes</Radio>
							<Radio value={false}>No</Radio>
						</Radio.Group>
					</Form.Item>
				</Col>
				<Col span={24} md={20}>
					<Form.Item
						label="If yes, Attach tax exempt certificate"
						name="taxExemptCertificate"
						valuePropName="fileList"
						getValueFromEvent={normFile}
					>
						<Upload
							beforeUpload={() => false}
							maxCount={1}
							multiple={false}
							accept=".pdf"
						>
							<Button
								icon={<UploadOutlined />}
								size="large"
								disabled={hasTaxCertificate}
							>
								Upload
							</Button>
						</Upload>
						{hasTaxCertificate && (
							<Text
								type="success"
								style={{ underline: true, cursor: "pointer" }}
								onClick={() => {
									const link = document.createElement("a");
									link.href = taxCertificate;
									link.target = "_blank";
									document.body.appendChild(link);
									link.click();
									link.remove();
								}}
							>
								Tax Exempt Certificate already attached
							</Text>
						)}
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="PO Required?" name="poRequired">
						<Radio.Group>
							<Radio value={true}>Yes</Radio>
							<Radio value={false}>No</Radio>
						</Radio.Group>
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Invoice Method:" name="invoiceMethod">
						<Radio.Group>
							<Radio value={"Email"}>Email</Radio>
							<Radio value={"Mail"}>Mail</Radio>
						</Radio.Group>
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Send To (Email or Mailing Address)"
						name="invoiceSendTo"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Buyer Certification & Agreement</center>
			</div>
			<div>
				<small>
					Buyer certifies that it is solvent and capable of meeting its
					obligations hereunder, and that all information (including any
					requested financial statements) provided to 57 Concrete, LLC and/or
					its subsidiaries and affiliates ("Seller") is true, accurate and
					complete. All such information has been submitted for the purpose of
					obtaining credit. Buyer and each Guarantor authorize Seller to request
					credit reports from credit bureaus (including consumer reporting
					agencies) regarding their respective commercial or personal credit and
					otherwise to investigate their respective creditworthiness before
					extending credit now or at any time in the future. Buyer also agrees
					to comply with all applicable bulk sales laws. Buyer agrees that all
					Terms and Conditions of Sale on the reverse side of this Credit
					Application, as the same may be amended from time to time, shall apply
					to all sales and extensions of credit made to Buyer by Seller. Buyer
					agrees that all Terms and Conditions of Sale on Page 4 of this Credit
					Application, as the same may be amended from time to time, shall apply
					to all sales and extensions of credit made to Buyer by Seller.
				</small>
			</div>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>Authorized Signature (Applicant)</center>
			</div>
			<Row gutter={16}>
				<Col span={24} sm={6}>
					<Form.Item
						label="Name/Title"
						name="signatureName"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" placeholder="Signature Name" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Email"
						name="signatureEmail"
						rules={[
							{ type: "email", message: "Email not valid" },
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Phone"
						name="signaturePhone"
						rules={[
							{
								required: true,
								message: "Field required",
							},
						]}
					>
						<Input size="large" addonBefore={prefixSelector} />
					</Form.Item>
				</Col>
				<Col span={24} sm={6}>
					<Form.Item
						label="Date"
						name="signatureDate"
						// rules={[
						// 	{
						// 		required: true,
						// 		message: "Field required",
						// 	},
						// ]}
					>
						<DatePicker
							size="large"
							style={{ width: "100%" }}
							format={"MM/DD/YYYY"}
							disabled
						/>
					</Form.Item>
				</Col>
			</Row>
			<div style={{ backgroundColor: "lightgrey" }}>
				<center>
					<strong>TERMS AND CONDITIONS OF SALE</strong> (“Terms”)
				</center>
			</div>
			<div className="small">
				<ol>
					<li>
						All references in this document to "Seller" shall include 57
						Concrete LLC and/or any parent, subsidiary or affiliate of 57
						Concrete LLC (including any division of the foregoing) whether or
						not performing any or all of the scope hereunder or specifically
						identified herein. All references to "Buyer" shall include all
						parent(s), subsidiaries and affiliates of the entity placing the
						order. Buyer and Seller may be referred to individually as a "Party"
						and collectively as "Parties".
					</li>
					<li>
						All sales to Buyer are subject to these Terms, which shall prevail
						over any inconsistent terms of Buyer's purchase order or other
						documents. Additional or different terms and conditions in any way
						altering or modifying these Terms are expressly objected to and
						shall not be binding upon Seller unless specifically accepted in
						writing by Seller's authorized representative. No modification or
						alteration of these Terms shall result by Seller's shipment of goods
						following receipt of Buyer's purchase order, or other documents
						containing additional, conflicting or inconsistent terms. There are
						no terms, conditions, understandings, or agreements other than those
						stated herein, and all prior proposals and negotiations are merged
						herein. These Terms are binding on the Parties, their successors,
						and permitted assigns.
					</li>
					<li>
						Prices in Seller quotes are subject to change without notice, and
						all such prices expire and become invalid if not accepted within 10
						calendar days from the date of issue, unless otherwise noted by
						Seller in writing. Price extensions if made must be in writing only.
						All prices and other terms provided to Buyer shall be kept
						confidential except to the extent a Party is required by law to
						disclose the same.
					</li>
					<li>
						Seller shall not be liable for delay or default in delivery
						resulting from any cause beyond Seller's reasonable control,
						including, but not limited to, governmental action, strikes or other
						labor troubles, fire, damage or destruction of goods, wars (declared
						or undeclared), acts of terrorism, manufacturers' shortages,
						availability or timeliness of transportation, materials, fuels, or
						supplies, and acts of God (each a "Force Majeure Event"). Upon the
						occurrence of a Force Majeure Event: (a) the time for Seller's
						performance shall be extended reasonably and the Parties shall
						adjust all affected dates accordingly; (b) the purchase price shall
						be adjusted for any increased costs to Seller resulting from such
						Force Majeure Event; and (c) Buyer shall not be entitled to any
						other remedy.
					</li>
					<li>
						Buyer shall indemnify, defend, and hold Seller its officers,
						directors, employees and agents harmless from any and all costs
						(including attorneys' and accountants' fees and expenses),
						liabilities and damages resulting from or related to any third party
						(including Buyer's employees) claim, complaint and/or judgment
						arising from Buyer's use of any goods furnished hereunder, as well
						as any negligent, intentional, or tortious act or omission of Buyer
						or any material breach by Buyer of these Terms.
					</li>
					<li>
						When materials are delivered to Buyer, Buyer shall sign each
						individual delivery ticket to ensure proper accounting at the time
						of invoicing. Title and risk of loss shall pass to Buyer at the
						applicable delivery location. All claims as to which Seller has the
						risk of loss shall be waived unless Buyer, within 2 calendar days
						after receipt of the material, gives Seller written notice fully
						describing the alleged claim.
					</li>
					<li>
						Any change in product specifications, quantities, destinations,
						shipping schedules, or any other aspect of the scope of goods must
						be agreed to in writing by Seller, and may result in a price and
						delivery adjustment by Seller. No credit for goods returned by Buyer
						shall be given without Seller's written authorization.
					</li>
					<li>
						Unless otherwise agreed in writing, payment terms are Cash on
						Delivery, payable in United States of America ("U.S.") dollars.
						Notwithstanding the foregoing, all orders are subject to Seller's
						continuing approval of Buyer's credit. If Buyer's credit is not
						approved or becomes unsatisfactory to Seller then Seller, in its
						sole discretion, may suspend or cancel performance, or require
						different payment terms, including but not limited to cash on
						delivery or in advance of shipment. Payments due hereunder shall be
						made in the form of cash, check, wire transfer or money order, or
						other tender approved in writing by Seller. Seller may, in its sole
						discretion, apply Buyer's payment against any open charges. Past due
						accounts bear interest at the lesser of 4.0% per day or the maximum
						rate permitted by applicable law, continuing after Seller obtains
						judgment against Buyer. Seller may exercise setoff or recoupment to
						apply to or satisfy Buyer's outstanding debt. Buyer shall have no
						right of setoff hereunder, the same being expressly waived hereby.
						Seller expressly reserves its right to file liens if payment is not
						received for its materials and expressly disclaims any waiver of
						lien rights language which may be contained in any future agreements
						between the Parties hereto. Seller reserves all rights to invoice
						and be paid for materials provided to Buyer and any terms contained
						in any of Buyer's purchase orders or other documents that purport to
						limit in any way the time or manner within which Seller may invoice
						are hereby waived by Buyer.
					</li>
					<li>
						Buyer shall pay Seller all costs and expenses of collection, suit,
						or other legal action brought as a result of the commercial
						relationship between them, including, but not limited to, all actual
						attorneys' and paralegals' fees, and collection costs, incurred
						pre-suit, through trial, on appeal, and in any administrative or
						bankruptcy proceedings. Any cause of action that Seller has against
						Buyer may be assigned without Buyer's consent to 57 Concrete LLC or
						to any affiliate, parent or subsidiary of 57 Concrete LLC.
					</li>
					<li>
						This Agreement, Buyer's account, and the business relationship
						between Buyer and Seller shall be governed by and construed in
						accordance with the laws of the state where the applicable project
						is located without regard to conflicts of laws rules, and
						specifically excluding the UN Convention on Contracts for the
						International Sale of Goods. The Parties agree that any legal action
						arising under or related to this Agreement may be brought in the
						applicable federal or state court where the project is located, and
						any right to object to such venue or to assert the inconvenience of
						such forum is hereby waived.
					</li>
					<li>
						If Buyer fails to comply with these Terms, Seller may terminate or
						restrict any order immediately upon notice to Buyer. Buyer certifies
						that it is solvent and that it will advise Seller immediately if it
						becomes insolvent. Buyer agrees to send Seller written notice of any
						changes in the form of ownership of Buyer's business within 5 days
						of such changes. Buyer and Seller are the only intended
						beneficiaries of this document, and there are no third party
						beneficiaries.
					</li>
					<li>
						The invalidity or unenforceability of all or part of these Terms
						will not affect the validity or enforceability of the other terms.
						The parties agree to replace any void or unenforceable term with a
						new term that achieves substantially the same practical and economic
						effect and is valid and enforceable.
					</li>
					<li>
						The following provisions shall survive termination, cancellation and
						completed performance of this Agreement as long as necessary to
						allow the aggrieved party to fully enforce such clauses: 5, 6, 9,
						10, 11 and 12.
					</li>
				</ol>
			</div>
			<div>
				<div style={{ backgroundColor: "lightgrey" }}>
					<center>Personal Guaranty</center>
				</div>
				<div className="small">
					In consideration of the extension of credit by 57 Concrete to the
					applicant named above, the undersigned, jointly and severally,
					unconditionally guarantee the prompt payment of all amounts now or
					hereafter owed by the applicant to 57 Concrete. This is a continuing
					guaranty. The undersigned waives notice of acceptance and demand, and
					authorizes 57 Concrete to obtain consumer credit reports on the
					undersigned in connection with this guaranty.
				</div>
				<Row gutter={16}>
					<Col span={24} sm={5}>
						<Form.Item
							label="First Guarantor's Name"
							name="guarantorName1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First guarantor Name" />
						</Form.Item>
					</Col>
					<Col span={24} sm={5}>
						<Form.Item
							label="Title"
							name="guarantorPosition1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First guarantor Title" />
						</Form.Item>
					</Col>
					<Col span={24} sm={5}>
						<Form.Item
							label="Date of Birth"
							name="guarantorDate1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<DatePicker
								size="large"
								style={{ width: "100%" }}
								format={"MM/DD/YYYY"}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={5}>
						<Form.Item
							label="S/S Number"
							name="guarantorSS1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First guarantor S/S Number" />
						</Form.Item>
					</Col>
					<Col span={24} sm={4}>
						<Form.Item
							label="Phone"
							name="guarantorPhone1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input
								size="large"
								placeholder="First Guarantor Phone"
								addonBefore={prefixSelector}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="Address"
							name="guarantorAddress1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First Guarantor Address" />
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="City"
							name="guarantorCity1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First Guarantor City" />
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="State"
							name="guarantorState1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First Guarantor State" />
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="Zip"
							name="guarantorZip1"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="First Guarantor Zip" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24} sm={5}>
						<Form.Item
							label="Second Guarantor's Name"
							name="guarantorName2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second guarantor Name" />
						</Form.Item>
					</Col>
					<Col span={24} sm={5}>
						<Form.Item
							label="Title"
							name="guarantorPosition2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second guarantor Title" />
						</Form.Item>
					</Col>
					<Col span={24} sm={5}>
						<Form.Item
							label="Date of Birth"
							name="guarantorDate2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<DatePicker
								size="large"
								style={{ width: "100%" }}
								format={"MM/DD/YYYY"}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={5}>
						<Form.Item
							label="S/S Number"
							name="guarantorSS2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second guarantor S/S Number" />
						</Form.Item>
					</Col>
					<Col span={24} sm={4}>
						<Form.Item
							label="Phone"
							name="guarantorPhone2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input
								size="large"
								placeholder="Second Guarantor Phone"
								addonBefore={prefixSelector}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="Address"
							name="guarantorAddress2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second Guarantor Address" />
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="City"
							name="guarantorCity2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second Guarantor City" />
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="State"
							name="guarantorState2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second Guarantor State" />
						</Form.Item>
					</Col>
					<Col span={24} sm={6}>
						<Form.Item
							label="Zip"
							name="guarantorZip2"
							rules={[
								{
									required: true,
									message: "Field required",
								},
							]}
						>
							<Input size="large" placeholder="Second Guarantor Zip" />
						</Form.Item>
					</Col>
				</Row>
			</div>
			<Divider />

			<Row gutter={16}>
				<Col span={24} sm={12} md={4}>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						style={{
							width: "100%",
						}}
						disabled={loadingCredit}
						loading={loadingCredit}
					>
						{creditApplicationCreated
							? "Update Credit Form"
							: "Create Credit Form"}
					</Button>
				</Col>
				{creditApplicationCreated && !creditApproved && (
					<Col>
						<Button
							type="primary"
							danger
							htmlType="button"
							size="large"
							loading={loadingCredit}
							onClick={updateCreditApproved}
						>
							Approve Credit
						</Button>
					</Col>
				)}
			</Row>
		</Form>
	);

	const RenderTabs = () => (
		<Flex gap={6} vertical>
			<Flex gap={6} vertical align="end">
				<Button
					type="primary"
					size="large"
					htmlType="button"
					onClick={onSendCreditApplication}
					disabled={loadingButton}
					loading={loadingButton}
				>
					Send Credit Application
				</Button>
			</Flex>
			<Tabs
				defaultActiveKey="1"
				activeKey={activeKey}
				onChange={(value) => {
					setActiveKey(value);
				}}
				type="card"
				size={"large"}
				style={{ marginBottom: 32 }}
				items={[
					{
						label: "Customer",
						key: "1",
						children: <CustomForm />,
					},
					{
						label: "Credit Application",
						key: "2",
						children: <CreditForm />,
						disabled: !isCredit,
						// disabled: !isCredit || !creditApplicationCreated,
					},
				]}
			/>
		</Flex>
	);

	const onChangeFranchise = (v) => {
		if (v === "Valley Wide") {
			form.setFieldValue("prospectionSeller", "68d340ee5307a2f6813f110f");
		} else {
			form.setFieldValue("prospectionSeller", undefined);
		}
		setFranchise(v);
	};

	const onOkPurchaseOrder = async () => {
		// Si ya existe un Purchase Order vigente del servidor, el modal es de solo lectura
		if (hasActivePurchaseOrder) {
			setOpenPurchaseOrderModal(false);
			return;
		}

		try {
			const values = await formPurchaseOrder.validateFields();

			if (!values.purchaseOrder || values.purchaseOrder.length === 0) {
				openNotification("warning", "Warning", "Please attach a PDF file");
				return;
			}

			setPendingPurchaseOrder({
				file: values.purchaseOrder[0].originFileObj,
				fileName: values.purchaseOrder[0].name,
				expiredDate: values.expiredDate,
			});

			setOpenPurchaseOrderModal(false);
		} catch (err) {
			// validateFields lanza error si hay campos inválidos; AntD ya marca los campos en rojo
			console.error(err);
		}
	};

	const hasActivePurchaseOrder = purchaseOrders.length > 0;

	const RenderPurchaseOrderModal = () => {
		return (
			<Modal
				title="Purchase Order"
				open={openPurchaseOrderModal}
				onCancel={() => setOpenPurchaseOrderModal(false)}
				onOk={onOkPurchaseOrder}
				okButtonProps={{
					disabled: hasActivePurchaseOrder,
				}}
				width={600}
			>
				<Form form={formPurchaseOrder} layout="vertical">
					<Form.Item
						label="Purchase Order File (PDF)"
						name="purchaseOrder"
						valuePropName="fileList"
						getValueFromEvent={normFile}
						rules={[
							{
								required: !hasActivePurchaseOrder,
								message: "Please attach the purchase order file",
							},
						]}
					>
						<Upload
							beforeUpload={() => false}
							maxCount={1}
							multiple={false}
							accept=".pdf"
							disabled={hasActivePurchaseOrder}
						>
							<Button
								icon={<UploadOutlined />}
								size="large"
								disabled={hasActivePurchaseOrder}
							>
								Upload
							</Button>
						</Upload>
					</Form.Item>
					<Form.Item
						label="Expired Date"
						name="expiredDate"
						rules={[
							{
								required: !hasActivePurchaseOrder,
								message: "Please select the expired date",
							},
						]}
					>
						<DatePicker
							size="large"
							style={{ width: "100%" }}
							showTime={{ format: "HH:mm" }}
							format="MM/DD/YYYY HH:mm A"
							disabled={hasActivePurchaseOrder}
							disabledDate={(current) =>
								current && current < dayjs().startOf("day")
							}
						/>
					</Form.Item>
				</Form>

				<Divider />
				<Title level={5}>Current Purchase Order</Title>
				<CustomTable
					columns={columnsPurchaseOrder}
					data={purchaseOrdersList}
					isScroll={false}
				/>

				{!hasActivePurchaseOrder && pendingPurchaseOrder && (
					<Text type="warning">
						This Purchase Order will be saved when you click "Save" on the
						customer form.
					</Text>
				)}
			</Modal>
		);
	};

	return (
		<Layout title="Customer" description="Edit Customer" type="large">
			{loadingOption ? <CustomSpinner /> : <RenderTabs />}
			{contextHolder}
			<RenderPurchaseOrderModal />
		</Layout>
	);
};

export default CustomerProfile;
